export default "__VITE_ASSET__CV5aya2L__"